
import { IOpChangeState, IJsonSerializable, ICopyable } from '../util/interfaces'
import { Enums } from '../common/enums'

import { OpDataType } from './op-data-type'
import { OpAlarmGroup } from './op-alarm-group';
import { OpOperator } from './op-operator';

export class OpAlarmGroupOperator
    implements IOpChangeState
    , IJsonSerializable
    , ICopyable<OpAlarmGroupOperator>
{
    //#region Properties

    public idAlarmGroup: number
    public idOperator: number
    public idDataType: number

    //#endregion

    //#region  Navigation Properties

    public alarmGroup: OpAlarmGroup
    public operator: OpOperator
    public dataType: OpDataType

    //#endregion

    //#region Custom Properties

    //#endregion 

    // #region Ctor

    constructor(opObj: any) {
        if (opObj instanceof OpAlarmGroupOperator) {
            this.copy(<OpAlarmGroupOperator>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    // #endregion

    // #region IOpChangeState

    public opState: Enums.OpChangeState

    // #endregion

    //#region IJsonSerializable

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {

            this.alarmGroup = opObj._AlarmGroup == null ? null : new OpAlarmGroup(opObj._AlarmGroup)
            this.operator = opObj._Operator == null ? null : new OpOperator(opObj._Operator)
            this.dataType = opObj._DataType == null ? null : new OpDataType(opObj._DataType)

            this.idAlarmGroup = opObj.ID_ALARM_GROUP
            this.idOperator = opObj.ID_OPERATOR
            this.idDataType = opObj.ID_DATA_TYPE

            this.opState = opObj.OpState

        } else {

            this.idAlarmGroup = 0
            this.idOperator = 0
            this.idDataType = 0

            this.opState = Enums.OpChangeState.New
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_ALARM_GROUP: this.idAlarmGroup,
            ID_OPERATOR: this.idOperator,
            ID_DATA_TYPE: this.idDataType,

            _AlarmGroup: this.alarmGroup == null ? null : this.alarmGroup.toJSON(),
            _Operator: this.operator == null ? null : this.operator.toJSON(),
            _DataType: this.dataType == null ? null : this.dataType.toJSON(),

            OpState: this.opState
        }
    }

    //#endregion

    //#region ICopyable

    public copy(sourceObject: OpAlarmGroupOperator, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {

        if (sourceObject == null) {
            return null
        }

        if (includeNavigationProperties) {
            this.alarmGroup = sourceObject.alarmGroup == null ? null : sourceObject.alarmGroup.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

            this.operator = sourceObject.operator == null ? null : sourceObject.operator.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

            this.dataType = sourceObject.dataType == null ? null : sourceObject.dataType.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)
        }

        if (includeCustomProperties) {
            // No Custom Properties
        }

        if (includeDataList) {
            // No Data List
        }

        if (includeDynamicValues) {
            // No Dynamic Values
        }

        this.idAlarmGroup = sourceObject.idAlarmGroup
        this.idOperator = sourceObject.idOperator
        this.idDataType = sourceObject.idDataType

        this.opState = sourceObject.opState
    }

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): OpAlarmGroupOperator {
        const group: OpAlarmGroupOperator = new OpAlarmGroupOperator(null)

        group.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return group
    }

    //#endregion
}